<div class="agpr-termsOfService">
    <nav
        class="agpr-termsOfService-navigation"
    >
        <ng-container *ngIf="logoUrl">
            <img
                [src]="logoUrl"
                [alt]="logoAltText | localize"
                class="agpr-termsOfService-navigation-logo"
            >
            <div class="agpr-termsOfService-navigation-links" *ngIf="!isResellerDomain">
                <span>{{'Core.termsOfService.connect' | localize}}</span>
                <a href="https://x.com/AgilityPRS" target="_blank" [agprTooltip]="'Core.termsOfService.x'"><span class="fa-brands fa-x-twitter"></span></a>
                <a href="https://www.facebook.com/AgilityPRSolutions" target="_blank" [agprTooltip]="'Core.termsOfService.facebook'"><span class="fa-brands fa-facebook"></span></a>
                <a href="https://www.agilitypr.com/feed/" target="_blank" [agprTooltip]="'Core.termsOfService.rss'"><span class="fa fa-rss"></span></a>
            </div>
        </ng-container>
    </nav>
    <main
        class="agpr-termsOfService-body"
    >
        <div class="agpr-termsOfService-content">
            <h1 class="agpr-headerH1-dark">
                <span
                    role="img"
                    aria-hidden="true"
                    class="fa-light fa-file-circle-check"
                ></span>
                {{'Core.termsOfService.header' | localize}}
            </h1>
            <!-- <agpr-scroll-panel
                (scrolledToBottom)="scrolledToBottom = true;"
            > -->
                <!-- <agpr-message [severity]="'info'">{{'Core.termsOfService.message' | localize}}</agpr-message> -->
                <div class="agpr-termsOfService-text" [innerHTML]="body"></div>
            <!-- </agpr-scroll-panel> -->
        </div>
        <agpr-action-bar>
            <ng-template #left>
                <agpr-button
                    label="Core.termsOfService.decline"
                    [style]="buttonTypes.secondary"
                    (click)="decline()"
                ></agpr-button>
            </ng-template>
            <ng-template #right>
                <agpr-button
                    label="Core.termsOfService.accept"
                    (click)="accept()"
                    [style]="buttonTypes.primary"
                ></agpr-button>
                <!-- [disabled]="!scrolledToBottom" -->
            </ng-template>
        </agpr-action-bar>
    </main>
</div>
